import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import {useRequest} from 'vue-request'
import {CurrencyCode} from "@/models/core/currency";

export abstract class DataModel {
  data: any = null;

  loading = false;

  loaded = false;

  method = 'loadAccountsList';

  url = '/webapi/finance/history';

  public getData(): any {
    return {};
  }

  hasMerchantAccounts(): boolean {
    if (!this.loaded) return false;

    for (const account of this.data.accounts) if (account.isHold) return true;

    return false;
  }

  loadData(): any {
    this.loading = true;
    this.loaded = false;

    return httpAxiosApi.post(this.url,
      {call: this.method, ...this.getData()}).then((result: any) => {
      const {data} = result;
      this.data = data.model;
      this.loading = false;
      this.loaded = true;

      return data.model;
    }, (err) => {
      this.loading = false;
      this.loaded = false;
      throw err;
    });
  }
}

export class LastHistoryLoadModel extends DataModel {
  method = 'lastHistory';
}

export class FiatAccountsModel extends DataModel {
  method = 'fiatAccounts';

  data: any = {crypto: {wallets: [], maxCount: 10}, massPaymentSummary: {}};

  countWalletsInCurrency(currency = 'BTC'): number {
    let result = 0;
    for (const wallet of this.data.crypto.wallets) {
      if (wallet.currency == currency) result++;
    }
    return result;
  }

  currencyLimitReached(currency = 'BTC'): boolean {
    return this.countWalletsInCurrency(currency) >= this.data.crypto.maxCount;
  }
}

export function DocumentStateTitleFilter(document: any,
                                         titleManualProcess = 'Платеж переведен на ручную обработку. Наш персонал постарается обработать вашу заявку максимально быстро. Благодарим за понимание.',
                                         titleInprocess = 'Платеж в обработке.',
                                         titleExecuted = 'Платеж исполнен.',
                                         titleDeclined = 'Платеж отклонен.'): string {
  if (document.inprocessmanual || (document.state == 'inprocess_manual')) return titleManualProcess;
  if (document.state == 'inprocess') return titleInprocess;
  if (document.state == 'executed') return titleExecuted;
  if (document.state == 'declined') return document.comment ? document.comment : titleDeclined;
  return titleInprocess;
}

export const fetchUserCryptoAccountsInfo = () => {
  return httpAxiosApi.get('/webapi/finance/accounts/cryptoAccounts')
    .then((response) => {
      return {
        incomingInfo: null,
        incomingSum: null,
        addresses: null,
        accounts: null,
        ...response.data
      }
    })
}

export const useUserCryptoAccountsInfoMod = () => {
  return useRequest(fetchUserCryptoAccountsInfo, {
    cacheKey: () => '/webapi/finance/accounts/cryptoAccounts',
    cacheTime: 120000,
    staleTime: 120000,
    debounceInterval: 200,
    errorRetryCount: 5,
    errorRetryInterval: 3000,
    pollingInterval: 50000,
    pollingWhenHidden: false,
    pollingWhenOffline: false,
    refreshOnWindowFocus: true,
  })
};

export const fetchUserFiatAccountsInfo = () => {
  return httpAxiosApi.post('/webapi/finance/accounts/fiatAccounts')
    .then((response) => {
      return {...response.data}
    })
}

export const useUserFiatAccountsInfo = (options = {}) => {
  return useRequest(fetchUserFiatAccountsInfo, {
    cacheKey: () => '/webapi/finance/accounts/fiatAccounts',
    cacheTime: 60000,
    staleTime: 60000,
    debounceInterval: 200,
    errorRetryCount: 5,
    errorRetryInterval: 3000,
    pollingInterval: 50000,
    pollingWhenHidden: false,
    pollingWhenOffline: false,
    refreshOnWindowFocus: true,
    ...options
  })
};

export const filterCryptoInfoDataByCurrency = (cryptoInfoData, currency = CurrencyCode.BTC) => {
  return {
    accounts: cryptoInfoData.accounts?.filter((item) => {
      return item.currency === currency;
    }),
    addresses: cryptoInfoData.addresses?.filter((item) => {
      return item.currency === currency;
    }),
    incomingInfo: cryptoInfoData.incomingInfo?.filter((item) => {
      return item.currency === currency;
    }),
    incomingSum: cryptoInfoData.incomingSum[currency] || 0
  }
}

export const countWalletsInCurrency = (currency: string = 'BTC', cryptoWallets: any[]): number => {
  let result = 0;
  for (const wallet of cryptoWallets) {
    if (wallet.currency == currency)
      result++;
    if ((wallet.currency == 'USDTt') && (currency === 'USDT'))
      result++;
  }
  return result;
}

export const currencyLimitReached = (currency: string = 'BTC', cryptoWallets: any[], maxCount = 0): boolean => {
  return countWalletsInCurrency(currency, cryptoWallets) >= maxCount;
}

export const updateUsdtAddresses = (addresses: any[], cryptoWallets: any[]) => {
  const result = [...cryptoWallets];
  for (const addr of addresses) {
    let found = false;
    for (let i = 0; i < result.length; i++) {
      if (result[i].id === addr.id) {
        result.splice(i, 1, addr);
        found = true;
        break;
      }
    }
    if (!found)
      result.push(addr);
  }
  return result;
}

export const renameUserAccount = (number: string, newName: string) => {
  return httpAxiosApi.post('/webapi/finance/accounts/renameAccount', {
    m: {
      accountNumber: number,
      name: newName
    }
  }).then((response) => {
    return {...response.data.account}
  })
}
